export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FullWidthBanner.vue?vue&type=template&id=2e90a99a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FullWidthBanner.vue?vue&type=template&id=2e90a99a&scoped=true
// module id = 145
// module chunks = 0